<template>
<div class="invite_main">
    <div class="invite_header">
        <!-- <div class="icon">
                <div class="eng">广州劳动仲裁院</div>
                <div>GUANGZHOU LABOR ARBITRATION COURT</div>
            </div> -->
        <div class="title">广州劳动人事微仲裁</div>
    </div>
    <div class="invite_content">
        <div class="invite-login">
            <div class="login-title">
                <div class="title">登 录</div>
                <div class="bottom-line">Sign in</div>
            </div>
            <el-form :model="invite" :rules="inviterules" @submit.native.prevent ref="invite" class="demo-ruleForm">
                <el-form-item prop="mobilePhone">
                    <el-input class="invite_input" maxlength="11" v-model="invite.mobilePhone" @keyup.enter="submitForm('invite')" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item prop="inviteCode">
                    <el-input class="invite_input" v-model="invite.inviteCode" @keyup.enter="submitForm('invite')" placeholder="请输入邀请码"></el-input>
                </el-form-item>
            </el-form>
            <div style="display:flex;justify-content: space-between;">
                <!-- <router-link style="color: #0083c8; cursor:pointer" :to="'./loginWorker'">工作人员登录</router-link> -->
                <a style="color: #0083c8; cursor:pointer" target="_blank" href="/abilitytest/index.html">视频支持能力检测</a>
            </div>
            <div class="enter" @click="submitForm('invite')">登录</div>
        </div>
    </div>
    <el-dialog width="345px" title="扫描二维码" class="el-dialog-notification" :visible.sync="innerVisible" :close-on-click-modal=false :before-close="handleClose">
        <p>扫码完成实名认证后进入视频</p>
        <div class="code-content">
            <img :src="weixincode" :alt="'人脸认证'">
            <div class="refresh-code" v-if="refreshCode" @click="handleRefreshCode">点击刷新二维码</div>
        </div>
        <p class="invalid-code" v-if="refreshCode">{{refreshName}}</p>
    </el-dialog>
    <el-dialog title="异步庭审公告" class="ggDialog" :visible.sync="gonggaoVisible" width="30%" center :show-close="false">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;根据我国法律的有关规定，当事人在仲裁活动中享有如下权利：有委托代理人、申请回避的权利，有申诉、申辩、质询、质证、辩论、陈述最后意见的权利，有请求调解、自行和解、要求裁决的权利，有依法向人民法院提起诉讼、申请强制执行的权利；申请人有放弃、变更、撤回仲裁请求的权利；被申请人有承认、反驳申请人仲裁请求、提起反诉的权利。</span><br>
        <span>
            &nbsp;&nbsp;&nbsp;&nbsp;当事人在仲裁活动中承担如下义务：有遵守仲裁程序和仲裁庭纪律的义务，有如实陈述案情、回答仲裁员提问的义务，有对自己提出的主张举证的义务，有尊重对方当事人及其他仲裁参加人的义务，有自觉履行发生法律效力的调解、裁决文书的义务。
        </span><br>
        <span>
            &nbsp;&nbsp;&nbsp;&nbsp;根据《中华人民共和国劳动争议调解仲裁法》第三十三条的规定，如果当事人认为本庭组成人员以及书记员与本案有利害关系或其他关系，可能影响到本案公正审理的情形，可以申请本庭组成人员回避，但应说明理由和依据。
        </span><br><br>
        <div class="notice">
            <span>
                温馨提示：可以在异步沟通中继续查看
            </span>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" style="border-radius:50px; width:120px;" @click="intoSystem">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import config from '@/config/config'
import {
    inviteEnterWatch
} from '@/api/meeting'
import {
    getRealNameVerifyStatusGzzc,
    getCaseStatus
} from '@/api/login.js'
import {
    setStore,
    getStore,
    removeStore,
    setStoreSession,
    getStoreSession
} from '@/utils/utils.js'
export default {
    data() {
        var validatePhone = (rule, value, callback) => {
            var myreg = /^1[3-9]\d{9}$/;
            if (value === '') {
                callback(new Error('请输入手机号'));
            } else if (!myreg.test(value)) {
                callback(new Error('手机号格式不正确'));
            } else {
                callback();
            }
        };
        return {
            invite: {
                mobilePhone: '',
                inviteCode: ''
            },
            inviterules: {
                mobilePhone: [{
                    required: true,
                    validator: validatePhone,
                    trigger: 'blur'
                }],
                inviteCode: [{
                    required: true,
                    message: '请输入邀请码',
                    trigger: 'blur'
                }]
            },
            inviteWatchData: '',
            checked: true,
            innerVisible: false,
            weixincode: '',
            timer: null,
            refreshCode: false,
            refreshName: '二维码已失效',
            gonggaoVisible: false
        }
    },
    mounted() {
        removeStore('loginInfo');
        removeStore('loginInfouser');
        removeStore('loginInfoEnterprise');
        setStore('isOutter', 0);
        removeStore('appName')
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    inviteEnterWatch(this.invite).then((res) => {
                        if (res.data.code === 1000) {
                            let data = res.data.data;
                            this.inviteWatchData = res.data.data;
                            removeStore('canUpload');
                            removeStore('loginInfo');
                            removeStore('loginInfouser');
                            removeStore('loginInfoEnterprise');
                            setStore('isOutter', 0);
                            removeStore('appName')
                            setStore('flk', data.token);
                            setStoreSession('haslogin', 'yes');
                            setStore('loginInfo', data);
                            console.log('~~~~~', data)
                            getCaseStatus({
                                caseId: data.caseId,
                                meetingId: data.meetingId
                            }).then((r) => {
                                if (r.data.data.mediationStatus == 'RUNNING' || r.data.data.mediationStatus == 'INIT') {
                                  // data.signName='艾晨'
                                    if (data.signName) {
                                        if (this.inviteWatchData.mediationMeetingType == "ASYNCHRONOUS_TRIAL") {
                                            this.$router.push({
                                                path: '/adjudgment',
                                                query: {
                                                    roomid: data.roomId,
                                                    caseid: data.caseId,
                                                    meetingid: data.meetingId,
                                                    token: data.token,
                                                    memberId: data.memberId,
                                                    memberName: data.memberName,
                                                    memberType: data.memberType,
                                                    spaceType: 0,
                                                    isClosed: false
                                                }
                                            })
                                        } else  if (this.inviteWatchData.mediationMeetingType == "ASYNCHRONOUS_MEDIATE" || this.inviteWatchData.mediationMeetingType == "ONLINE_SERVICE") {
                                            this.$router.push({
                                                path: '/caseSpace',
                                                query: {
                                                    roomid: data.roomId,
                                                    caseid: data.caseId,
                                                    meetingid: data.meetingId,
                                                    token: data.token,
                                                    memberId: data.memberId,
                                                    memberName: data.memberName,
                                                    memberType: data.memberType,
                                                    spaceType: this.inviteWatchData.mediationMeetingType == "ASYNCHRONOUS_MEDIATE"? 1 : 2,
                                                    isClosed: false
                                                }
                                            })
                                        } else {
                                            this.$router.push({
                                                path: '/agreement',
                                                query: {
                                                    roomid: data.roomId,
                                                    caseid: data.caseId,
                                                    meetingid: data.meetingId,
                                                    token: data.token,
                                                    memberId: data.memberId,
                                                    memberName: data.memberName,
                                                    memberType: data.memberType,
                                                    isClosed: false
                                                }
                                            })
                                        }
                                    } else {
                                        if(this.inviteWatchData.mediationMeetingType == 'MEDIATION_MEETING'){
                                             this.$router.push({
                                                path: '/agreement',
                                                query: {
                                                    roomid: data.roomId,
                                                    caseid: data.caseId,
                                                    meetingid: data.meetingId,
                                                    token: data.token,
                                                    memberId: data.memberId,
                                                    memberName: data.memberName,
                                                    memberType: data.memberType,
                                                    isClosed: false
                                                }
                                            })
                                        }else{
                                            this.isClosed = false
                                            this.ApiShowRealNameVerifyQRCode(data)
                                        }
                                    }
                                } else {
                                    this.$message.error('当前异步庭审已结束!')
                                    removeStore('loginInfo');
                                    removeStore('loginInfouser');
                                    removeStore('loginInfoEnterprise');
                                    return
                                }
                            })
                        } else {
                            this.$message.error(res.data.message)
                            this.reserror = res.data.message;
                            this.showreserror = true;
                            setTimeout(() => {
                                this.showreserror = false;
                            }, 2000)
                        }
                    }, (err) => {
                        this.$message.error(err)
                    })
                } else {
                    return false;
                }
            })
        },
        ApiShowRealNameVerifyQRCode(jsondata) {
            //显示二维码autograph为是否要签名的状态：0 不需要签名 1需预留签名
            let autograph = '0'
            if (this.invite.inviteCode.includes('YB') || this.invite.inviteCode.includes('TJ') || this.invite.inviteCode.includes('SD') || this.invite.inviteCode.length == 7) {
                autograph = 1
            }
            let jsonfile = `appName=gzzc&caseId=${jsondata.caseId}&meetingId=${jsondata.meetingId}&jwtToken=${jsondata.token}&autograph=${autograph}&authStatus=${jsondata.authStatus}&meetType=${jsondata.mediationMeetingType}`
            this.weixincode = `${config.baseURL}/gzzc/user/showRealNameVerifyQRCode?${jsonfile}`
            this.innerVisible = true
            this.timer = setInterval(() => {
                this.ApigetRealNameVerifyStatus(jsondata)
            }, 6000);
        },
        ApigetRealNameVerifyStatus(data) {
            //循环调用获取签名状态
            getRealNameVerifyStatusGzzc({
                meetingId: data.meetingId
            }).then((res) => {
                switch (res.data.code) {
                    case 1000:
                        if (data.mediationMeetingType == "ASYNCHRONOUS_MEDIATE" || data.mediationMeetingType == "ONLINE_SERVICE") {
                           this.$router.push({
                                                path: '/caseSpace',
                                                query: {
                                                    roomid: data.roomId,
                                                    caseid: data.caseId,
                                                    meetingid: data.meetingId,
                                                    token: data.token,
                                                    memberId: data.memberId,
                                                    memberName: data.memberName,
                                                    memberType: data.memberType,
                                                    spaceType: data.mediationMeetingType == "ASYNCHRONOUS_MEDIATE"? 1 : 2,
                                                    isClosed: false
                                                }
                              })                 
                        }else if (this.invite.inviteCode.startsWith("YB")|| this.invite.inviteCode.length == 7) {
                            this.$router.push({
                                path: '/adjudgment',
                                query: {
                                    roomid: data.roomId,
                                    caseid: data.caseId,
                                    meetingid: data.meetingId,
                                    token: data.token,
                                    memberId: data.memberId,
                                    memberName: data.memberName,
                                    memberType: data.memberType,
                                    isClosed: this.isClosed
                                }
                            })
                        } else {
                            this.$router.push({
                                path: '/agreement',
                                query: {
                                    roomid: data.roomId,
                                    caseid: data.caseId,
                                    meetingid: data.meetingId,
                                    token: data.token,
                                    memberId: data.memberId,
                                    memberName: data.memberName,
                                    memberType: data.memberType,
                                    isClosed: this.isClosed
                                }
                            })
                        }
                        break;
                    case 1103:
                        this.refreshCode = true
                        this.refreshName = '二维码已失效'
                        clearInterval(this.timer)
                        break;
                    case 1104:
                        this.refreshCode = true
                        this.refreshName = '认证失败'
                        clearInterval(this.timer)
                        break;
                    case 1005:
                        //结果为空，表示未获取到认证结果，继续等待
                        break;
                    default:
                        break;
                }
            }, (err) => {
                this.$message.error(err)
            })
        },
        goLogin() {
            this.$router.push({
                path: '/login'
            });
        },
        handleClose() {
            this.innerVisible = false
        },
        handleRefreshCode() {
            //过期刷新二维码
            this.refreshCode = false
            this.submitForm('invite')
        },
        intoSystem() {

        }
    },
    destroyed() {
        if (this.timer) { //如果定时器在运行则关闭
            clearInterval(this.timer);
        }
    },
    components: {

    }
}
</script>

<style lang="scss">
.invite_main {
    height: 100%;
    width: 100%;
    background: url("../../assets/bg.png") no-repeat center top;
    background-size: 100% 100%;
    overflow: hidden;

    .invite_header {
        display: flex;
        align-items: center;
        height: 110px;
        width: 85.5%;
        margin: 0 auto;
        color: #fff;

        .icon {
            position: relative;
            margin-right: 40px;

            .eng {
                font-size: 14px;
                letter-spacing: 25px;
            }
        }

        .icon:before {
            content: "";
            position: absolute;
            display: block;
            right: -10px;
            top: 10px;
            width: 1px;
            height: 0;
            border-top: 20px solid #ffffff;
        }

        .title {
            font-size: 28px;
            letter-spacing: 12px;
        }
    }

    .invite_content {
        position: relative;
        height: 80%;
        width: 85.5%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url("../../assets/bg_content.png") no-repeat center top;
        background-size: 100% 100%;

        .invite-login {
            position: absolute;
            right: 83px;
            height: 500px;
            padding: 0 50px;
            background-color: #fff;
            border-radius: 4px;

            .login-title {
                text-align: center;
                margin-bottom: 50px;

                .title {
                    padding-top: 60px;
                    font-size: 26px;
                    letter-spacing: 5px;
                    font-family: PingFang-SC-Medium;
                }

                .bottom-line {
                    font-size: 14px;
                    font-family: 'PingFang-SC-Light';
                    letter-spacing: 4px;
                }
            }

            .enter {
                margin: 100px auto;
                width: 300px;
                height: 46px;
                line-height: 46px;
                text-align: center;
                background-image: linear-gradient(90deg,
                        #408cf4 0%,
                        #3476f0 50%,
                        #2e6bed 100%),
                    linear-gradient(#0d44b0,
                        #0d44b0);
                background-blend-mode: normal,
                    normal;
                box-shadow: 0px 12px 24px 0px rgba(31, 115, 191, 0.2);
                border-radius: 24px;
                font-size: 18px;
                color: #fff;
                cursor: pointer;
            }

            .el-form-item {
                margin-bottom: 30px;

                .el-input__inner {
                    border: 0;
                    padding: 0;
                    border-bottom: 1px solid #dcdfe6;
                    border-radius: 0;
                }
            }
        }
    }

    .el-dialog-notification {
        .notification {
            padding-bottom: 20px;
        }

        .code-content {
            position: relative;

            .refresh-code {
                position: absolute;
                left: 0;
                top: 0;
                width: 300px;
                height: 300px;
                font-size: 20px;
                line-height: 300px;
                text-align: center;
                color: #0083c8;
                background: rgba(255, 255, 255, 0.9);
                cursor: pointer;
            }
        }

        p {
            text-align: center;
        }

        .invalid-code {
            font-size: 20px;
        }
    }

    .ggDialog {
        line-height: 25px;
        letter-spacing: 2px;
        font-weight: 400;

        .notice {
            width: 100%;
            display: flex;
            justify-content: center;
        }
    }

    .el-button {
        border-radius: 4px;
    }
}
</style>
